module.exports = __webpack_public_path__ + "img/alipay.ab790581.svg";